import { z } from 'zod';

export const DepositSchema = z.object({
  amount: z.number().positive('Valor deve ser positivo'),
  customer_id: z.string().optional(), // admin can deposit to another user
  description: z.string().optional().default('Depósito'),
});

export type DepositInput = z.infer<typeof DepositSchema>;

export const SetFeeSchema = z.object({
  fee_percent: z.number().min(0).max(100),
});

export type SetFeeInput = z.infer<typeof SetFeeSchema>;

export const CreateMarketplaceAgentSchema = z.object({
  name: z.string().min(2).max(100),
  description: z.string().optional(),
  category_id: z.string().optional(),
  is_marketplace: z.boolean().optional().default(false),
  price: z.number().min(0).optional().default(0),
  price_type: z.enum(['FREE', 'PAID']).optional().default('FREE'),
});

export type CreateMarketplaceAgentInput = z.infer<typeof CreateMarketplaceAgentSchema>;

export const UpdateMarketplaceActionSchema = z.object({
  is_marketplace: z.boolean().optional(),
  price: z.number().min(0).optional(),
  price_type: z.enum(['FREE', 'PAID']).optional(),
});

export type UpdateMarketplaceActionInput = z.infer<typeof UpdateMarketplaceActionSchema>;
